import { Col, List, Row, Skeleton } from "antd";
import {
  Box,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./GuestList.module.css";
import useWindowDimensions from "../../../../../hooks/useWindowDimensions";
import {
  BsCheckCircleFill,
  BsChevronDown,
  BsFillFilterSquareFill,
} from "react-icons/bs";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import { MdEmail, MdMessage } from "react-icons/md";
import { RiPhoneFill } from "react-icons/ri";
import { FaLocationDot } from "react-icons/fa6";
import Modal from "../../../../../components/modal/Modal";
import { memo, useEffect, useRef, useState } from "react";
import RsvpModal from "../../../../../components/rsvpModal/RsvpModal";
import { LocIcon } from "../../../../../components/icons/Icons";
import { EventPlanningMiddleware } from "../../../../../Store/Middlewares/EventPlanningMiddleware";
import { useDispatch, useSelector } from "react-redux";
import { roles } from "../../../../../config/roles";
import Storage from "../../../../../utills/AsyncStorage";

const PersonIcon = () => {
  return (
    <svg
      className={styles.svgIcon}
      viewBox="0 0 51 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M49.0039 18.4354V36.0563C49.0039 38.9415 47.4582 41.6207 44.9594 43.0891L29.657 51.9253C27.1582 53.368 24.0668 53.368 21.5422 51.9253L6.23987 43.0891C5.00789 42.3748 3.98557 41.3489 3.27563 40.1144C2.56568 38.8799 2.1931 37.4803 2.19532 36.0563V18.4354C2.19532 15.5501 3.74101 12.8709 6.23987 11.4025L21.5422 2.56636C24.041 1.12371 27.1324 1.12371 29.657 2.56636L44.9594 11.4025C47.4582 12.8709 49.0039 15.5244 49.0039 18.4354Z"
        className={styles.svgIconPath}
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M35.9178 39.2499C35.9178 34.6128 31.3065 30.8517 25.6132 30.8517C19.9199 30.8517 15.3086 34.6128 15.3086 39.2499M25.6132 24.6689C27.2051 24.6689 28.7319 24.0365 29.8575 22.9108C30.9832 21.7852 31.6156 20.2584 31.6156 18.6665C31.6156 17.0745 30.9832 15.5478 29.8575 14.4221C28.7319 13.2965 27.2051 12.6641 25.6132 12.6641C24.0212 12.6641 22.4945 13.2965 21.3688 14.4221C20.2432 15.5478 19.6108 17.0745 19.6108 18.6665C19.6108 20.2584 20.2432 21.7852 21.3688 22.9108C22.4945 24.0365 24.0212 24.6689 25.6132 24.6689Z"
        className={styles.svgIconPath}
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const PersonIcon2 = () => {
  return (
    <svg
      className={styles.svgIcon}
      viewBox="0 0 48 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7814 2.08895L6.80577 6.95156C3.8154 8.0697 1.37109 11.6061 1.37109 14.8045V34.125C1.37109 37.1933 3.39935 41.2238 5.86966 43.0701L17.0511 51.4171C20.7175 54.1735 26.7503 54.1735 30.4167 51.4171L41.5981 43.0701C44.0684 41.2238 46.0967 37.1933 46.0967 34.125V14.8045C46.0967 11.6061 43.6524 8.0697 40.662 6.95156L27.6864 2.08895C25.4761 1.28285 21.9397 1.28285 19.7814 2.08895Z"
        className={styles.svgIconPath}
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.707 24.6844H23.369C20.9247 24.6064 18.9744 22.5781 18.9744 20.1078C18.9744 17.5855 21.0287 15.5312 23.551 15.5312C26.0733 15.5312 28.1276 17.5855 28.1276 20.1078C28.1016 22.6041 26.1513 24.6064 23.707 24.6844ZM18.5324 31.9653C16.0361 33.6295 16.0361 36.3599 18.5324 38.0241C21.3667 39.9223 26.0213 39.9223 28.8557 38.0241C31.352 36.3599 31.352 33.6295 28.8557 31.9653C26.0473 30.0671 21.3927 30.0671 18.5324 31.9653Z"
        className={styles.svgIconPath}
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const StarIcon = () => {
  return (
    <svg
      className={styles.svgIcon}
      viewBox="0 0 69 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.2467 4.61094H1.63672M11.4417 50.3676H1.63672M4.90505 27.4893H1.63672M45.3997 5.29729L50.0081 14.514C50.6291 15.7886 52.2959 16.9979 53.7013 17.2594L62.0356 18.6321C67.3629 19.5145 68.6049 23.3712 64.781 27.2278L58.277 33.7318C57.1984 34.8104 56.5774 36.9348 56.937 38.4709L58.7999 46.511C60.2707 52.8516 56.8716 55.3355 51.2827 52.0018L43.4714 47.3608C42.066 46.511 39.7128 46.511 38.3074 47.3608L30.4961 52.0018C24.9073 55.3028 21.5082 52.8516 22.9789 46.511L24.8419 38.4709C25.2014 36.9675 24.5804 34.843 23.5019 33.7318L16.9979 27.2278C13.1739 23.4039 14.4159 19.5472 19.7433 18.6321L28.0776 17.2594C29.4829 17.0306 31.1498 15.7886 31.7708 14.514L36.3791 5.29729C38.8304 0.296737 42.8831 0.296737 45.3997 5.29729Z"
        className={styles.svgIconPath}
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const EditIcon = (
  <svg
    width="17"
    height="20"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3364 1.58691H10.8606C4.67111 1.58691 2.19531 4.06271 2.19531 10.2522V17.6796C2.19531 23.8691 4.67111 26.3449 10.8606 26.3449H18.288C24.4775 26.3449 26.9533 23.8691 26.9533 17.6796V15.2038"
      className={styles.svgIconPath}
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.5792 2.851L9.82459 12.6056C9.45322 12.977 9.08185 13.7074 9.00757 14.2397L8.47528 17.9657C8.27721 19.315 9.2304 20.2559 10.5797 20.0702L14.3058 19.5379C14.8257 19.4636 15.5561 19.0922 15.9398 18.7209L25.6944 8.96622C27.378 7.28267 28.1702 5.32679 25.6944 2.851C23.2186 0.375199 21.2628 1.16745 19.5792 2.851Z"
      className={styles.svgIconPath}
      stroke-width="2.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.1758 4.24658C18.5863 5.70417 19.3641 7.03193 20.4349 8.10269C21.5056 9.17345 22.8334 9.95132 24.291 10.3618"
      className={styles.svgIconPath}
      stroke-width="2.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const ViewIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 38 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.2183 16.8245C25.2183 20.3265 22.3885 23.1563 18.8865 23.1563C15.3846 23.1563 12.5547 20.3265 12.5547 16.8245C12.5547 13.3225 15.3846 10.4927 18.8865 10.4927C22.3885 10.4927 25.2183 13.3225 25.2183 16.8245Z"
      className={styles.svgIconPath}
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.8845 31.4472C25.1279 31.4472 30.9468 27.7684 34.9971 21.4012C36.5889 18.9074 36.5889 14.7156 34.9971 12.2218C30.9468 5.85461 25.1279 2.17578 18.8845 2.17578C12.6411 2.17578 6.82222 5.85461 2.77197 12.2218C1.18017 14.7156 1.18017 18.9074 2.77197 21.4012C6.82222 27.7684 12.6411 31.4472 18.8845 31.4472Z"
      className={styles.svgIconPath}
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const GuestModal = ({ item }) => {
  const role = Storage.getERole("@role");
  const navigate = useNavigate();
  const { age_group, guest_group, relation, contact_no, email, address, name } =
    item;

  const bottomLabels = [
    {
      icon: <RiPhoneFill className={styles.bottomIconCol} />,
      title: "Contact",
      value: contact_no,
    },
    {
      icon: <MdEmail className={styles.bottomIconCol} />,
      title: "Email",
      value: email,
    },
    {
      icon: <LocIcon className={styles.bottomIconCol} size={30} />,
      title: "Address",
      value: address,
    },
  ];

  return (
    <>
      <Row>
        <Col xs={24}>
          <Row>
            <TextComponent textClass={styles.modalName}>{name}</TextComponent>
          </Row>
          <Row className={styles.modalHeaderRow}>
            <Col>
              <Row className={styles.infoTopRow}>
                <Row>
                  <TextComponent textClass={styles.infoTopTitle}>
                    Age:&nbsp;
                  </TextComponent>
                  <TextComponent textClass={styles.infoTopValue}>
                    {age_group}
                  </TextComponent>
                </Row>
                <Row>
                  <TextComponent textClass={styles.infoTopTitle}>
                    Group:&nbsp;
                  </TextComponent>
                  <TextComponent textClass={styles.infoTopValue}>
                    {guest_group}
                  </TextComponent>
                </Row>
                <Row>
                  <TextComponent textClass={styles.infoTopTitle}>
                    Relation:&nbsp;
                  </TextComponent>
                  <TextComponent textClass={styles.infoTopValue}>
                    {relation}
                  </TextComponent>
                </Row>
              </Row>
            </Col>
            {role != roles.coHost && 
            <Col>
              <SubmitButton
                title="Message"
                outline={true}
                leftIcon={<MdMessage fontSize={"1.2rem"} />}
                btnClass={styles.msgBtn}
                onClick={() =>
                  navigate("/inbox", {  state: {
                    activeKey: '1',
                    chatData: item,
                    screenType: "guestDetailScreen",
                  }, })
                }
              />
            </Col>
            }
          </Row>
          <div
            style={{
              backgroundColor: "#C6C6C680",
              height: "2px",
              width: "100%",
            }}
          ></div>
          <Row className={styles.infoBottomRow}>
            {bottomLabels.map((label) => (
              <Row className={styles.infoBottomSingleRow}>
                <Col xs={1}>{label.icon}</Col>
                <Col xs={6} sm={5} md={4}>
                  <TextComponent textClass={styles.bottomLabelTitle}>
                    {label.title}:
                  </TextComponent>
                </Col>
                <Col xs={24} sm={14} className={styles.bottomLabelCol}>
                  <TextComponent textClass={styles.bottomLabelValue}>
                    {label.value}
                  </TextComponent>
                </Col>
              </Row>
            ))}
          </Row>
        </Col>
      </Row>
    </>
  );
};

const GroupHeader = () => {
  return (
    <Row className={styles.listItemFirst}>
      <Row className={styles.itemGroup1First}>
        <Col>
          <TextComponent text="Guest Name" textClass={styles.eventTitle} />
        </Col>
      </Row>
      <Row className={styles.itemGroup2First}>
        <Col xs={5} className={styles.group2first}>
          <TextComponent text="Relation" />
        </Col>
        <Col xs={6} className={styles.group2second}>
          <TextComponent text="Contact Number" />
        </Col>
        <Col xs={9} className={styles.group2third}>
          <TextComponent text="Email Address" textClass={styles.guests} />
        </Col>
        <Col xs={2} className={styles.group2fourth}></Col>
      </Row>
    </Row>
  );
};

const LeftGroup = ({ item }) => {
  return (
    <Row className={styles.itemGroup1}>
      <Col>
        <TextComponent text={item?.name} textClass={styles.eventTitle} />
      </Col>
    </Row>
  );
};

const RightGroup = ({ item, index }) => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      {index === 0 ? (
        <Row className={styles.itemGroup2First}>
          <Col xs={5} className={styles.group2first}>
            <TextComponent text="Event Date" textClass={styles.infoTitle} />
            <TextComponent text={item.relation} />
          </Col>
          <Col xs={6} className={styles.group2second}>
            <TextComponent text="Event Time" textClass={styles.infoTitle} />
            <TextComponent text={item.contactNumber} />
          </Col>
          <Col xs={9} className={styles.group2third}>
            <TextComponent text="Total Guests" textClass={styles.infoTitle} />
            <TextComponent text={item.emailAddress} textClass={styles.guests} />
          </Col>
          <Col xs={2} className={styles.group2fourth}></Col>
        </Row>
      ) : (
        <Row className={styles.itemGroup2}>
          <Col xs={24} sm={12} lg={5} className={styles.group2first}>
            <TextComponent text="Relation" textClass={styles.infoTitle} />
            <TextComponent text={item?.relation} />
          </Col>
          <Col xs={24} sm={12} lg={6} className={styles.group2second}>
            <TextComponent text="Contact Number" textClass={styles.infoTitle} />
            <TextComponent text={item?.contact_no} />
          </Col>
          <Col xs={24} sm={12} lg={9} className={styles.group2third}>
            <TextComponent text="Email Address" textClass={styles.infoTitle} />
            <TextComponent text={item?.email} textClass={styles.guests} />
          </Col>
          <Col xs={24} sm={12} lg={2} className={styles.group2fourth}>
            <span
              onClick={() => setModalOpen(true)}
              style={{ cursor: "pointer" }}
            >
              {ViewIcon}
            </span>
            &nbsp;&nbsp;
            {/* <span onClick={() => setModalOpen(true)} style={{cursor:'pointer'}}>{EditIcon}</span> */}
          </Col>
        </Row>
      )}
      <Modal
        isModalOpen={modalOpen}
        setIsModalOpen={setModalOpen}
        closable={true}
        // pinkBg={true}
        wideModal={true}
        className={styles.modalContent}
      >
        <GuestModal setModalOpen={setModalOpen} item={item} />
      </Modal>
    </>
  );
};

const SingleGroup = ({ group }) => {
  const { height, width } = useWindowDimensions();

  const [showGroups, setshowGroups] = useState(false);

  console.log("group", group);
  return (
    <>
      <Row className={styles.headingRow}>
        <Col>
          <TextComponent textClass={styles.headingText}>
            {group?.name} ({group?.total_members})
          </TextComponent>
        </Col>
        <Col>
          {showGroups ? (
            <BiChevronUp
              onClick={() => setshowGroups(!showGroups)}
              style={{ fontSize: "2rem", cursor: "pointer" }}
            />
          ) : (
            <BiChevronDown
              onClick={() => setshowGroups(!showGroups)}
              style={{ fontSize: "2rem", cursor: "pointer" }}
            />
          )}
        </Col>
      </Row>
      {showGroups && (
        <List
          header={<GroupHeader />}
          className={styles.list}
          itemLayout={width > 1050 ? "horizontal" : "vertical"}
          dataSource={group.data}
          renderItem={(item) => (
            <List.Item className={styles.listItem}>
              <LeftGroup item={item} />
              <RightGroup item={item} />
            </List.Item>
          )}
        />
      )}
      {/* <Row className={styles.headingRow}>
        <Col>
          <TextComponent textClass={styles.headingText}>
            Groom & Bride (02)
          </TextComponent>
        </Col>
        <Col>
          {showBrideGroom ? (
            <BiChevronUp
              onClick={() => setShowBrideGroom(false)}
              style={{ fontSize: "2rem", cursor: "pointer" }}
            />
          ) : (
            <BiChevronDown
              onClick={() => setShowBrideGroom(true)}
              style={{ fontSize: "2rem", cursor: "pointer" }}
            />
          )}
        </Col>
      </Row>
      {showBrideGroom && (
        <Row gutter={[16, 8]}>
          <Col xs={24} sm={12}>
            <Box boxClass={styles.groomBrideItem}>
              <TextComponent textClass={styles.brideGroomText}>
                Maria James
              </TextComponent>
            </Box>
          </Col>
          <Col xs={24} sm={12}>
            <Box boxClass={styles.groomBrideItem}>
              <TextComponent textClass={styles.brideGroomText}>
                Daniel Hamilton
              </TextComponent>
            </Box>
          </Col>
        </Row>
      )} */}
    </>
  );
};

const GuestList = () => {
  // const [groups, setGroups] = useState(groupsArr);
  const [rsvpModal, setrsvpModal] = useState(false);
  const [filterModal, setfilterModal] = useState(false);
  const [searchType, setSearchType] = useState("Group");
  const [showBrideGroom, setShowBrideGroom] = useState(false);
  const [loading, setloading] = useState(false);

  const timeout = useRef();

  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const GuestList = useSelector(
    (state) => state.EventPlanningReducer.GuestList
  );
  const eventDetails = useSelector((state) => state.EventReducer.EventDetails);

  const eventData = state?.eventData;

  // const handleToggle = (group) => {
  //   setGroups((prev) =>
  //     prev.map((item) => {
  //       if (item.title === group.title) {
  //         return { ...item, show: !item.show };
  //       } else {
  //         return item;
  //       }
  //     })
  //   );
  // };

  useEffect(() => {
    setloading(true);
    dispatch(EventPlanningMiddleware.getGuests({ id: eventData?.id })).then(
      () => {
        setloading(false);
      }
    );
  }, []);

  const stats1 = [
    { title: "Guests", value: eventDetails?.no_of_guest },
    { title: "Attending", value: eventDetails?.no_of_attendee },
  ];

  const stats2 = [
    {
      title: "Attending",
      value: eventDetails?.guest_stats?.attending
        ? eventDetails?.guest_stats?.attending
        : "--",
    },
    {
      title: "Pending",
      value: eventDetails?.guest_stats?.pending
        ? eventDetails?.guest_stats?.pending
        : "--",
    },
    {
      title: "Declined",
      value: eventDetails?.guest_stats?.declined
        ? eventDetails?.guest_stats?.declined
        : "--",
    },
  ];

  const stats3 = [
    {
      title: "Assigned Tables",
      value: eventDetails?.guest_stats?.assigned_table
        ? eventDetails?.guest_stats?.assigned_table
        : "--",
    },
  ];

  const onSearch = (val) => {
    // setsearch(val);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      // setLoading(true);
      dispatch(
        EventPlanningMiddleware.getGuests({
          id: eventDetails?.id,
          name: searchType == "Group" ? null : val,
          group: searchType == "Group" ? val : null,
        })
      );
      // .then(() => setLoading(false))
      // .catch(() => setLoading(false));
    }, 1500);
  };

  const options = ["Group", "Guest Name"];
  return (
    <>
      <Row className={styles.guestListHeader}>
        <Col xs={24} sm={12} lg={6}>
          <Row className={styles.contentRow}>
            <Col>
              <PersonIcon />
            </Col>
            <Row className={styles.textRow}>
              {stats1.map((stat) => (
                <Col>
                  <TextComponent textClass={styles.value}>
                    {stat.value}
                  </TextComponent>
                  <TextComponent textClass={styles.title}>
                    {stat.title}
                  </TextComponent>
                </Col>
              ))}
            </Row>
          </Row>
        </Col>
        <Col xs={24} sm={12} lg={9}>
          <Row className={styles.contentRow}>
            <Col>
              <StarIcon />
            </Col>
            <Row className={styles.textRow}>
              {stats2.map((stat) => (
                <Col>
                  <TextComponent textClass={styles.value}>
                    {stat.value}
                  </TextComponent>
                  <TextComponent textClass={styles.title}>
                    {stat.title}
                  </TextComponent>
                </Col>
              ))}
            </Row>
          </Row>
        </Col>
        <Col xs={24} md={12} lg={9}>
          <Row className={styles.contentRow}>
            <Col>
              <PersonIcon2 />
            </Col>
            <Row className={styles.textRow}>
              {stats3.map((stat) => (
                <Col>
                  <TextComponent textClass={styles.value}>
                    {stat.value}
                  </TextComponent>
                  <TextComponent textClass={styles.title}>
                    {stat.title}
                  </TextComponent>
                </Col>
              ))}
              <SubmitButton
                title="Request RSVP"
                btnClass={styles.rowBtn}
                onClick={() => setrsvpModal(true)}
              />
            </Row>
          </Row>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={16} md={18} xl={20}>
          <SearchInput
            onChange={(e) => onSearch(e.target.value)}
            // rightIcon={
            //   <BsFillFilterSquareFill
            //     size={25}
            //     className={styles.filterIcon}
            //     onClick={() => setfilterModal(!filterModal)}
            //   />
            // }
          />
          <div
            className={filterModal ? `${styles.optionDiv}` : styles.displayNone}
            // style={!label ? { top: "20px", marginTop: "0px" } : {}}
          >
            {options?.map((data, i) => (
              <div className={styles.option} key={i}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    margin: "5px",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    setSearchType(data);
                    setfilterModal(!filterModal);
                  }}
                >
                  <div>
                    <BsCheckCircleFill
                      size={20}
                      className={styles.icon}
                      color={
                        data == searchType ? "var(--primary-color)" : "#BEBEBE"
                      }
                    />
                  </div>
                  <span className={styles.optionText}>{data}</span>
                </div>
              </div>
            ))}
          </div>
        </Col>
        <Col xs={24} sm={8} md={6} xl={4}>
          <SubmitButton
            title="Add Guest"
            onClick={() =>
              navigate("/events/eventDetail/guests/addGuest", {
                state: { headrTitle: "Add Guest", eventData: state?.eventData },
              })
            }
            btnClass={styles.searchBtn}
          />
        </Col>
      </Row>
      <Skeleton loading={loading}>
        <List
          dataSource={GuestList?.guests?.length >0 ?GuestList?.guests:[] }
          renderItem={(group) => (
            <SingleGroup
              group={group}
              // handleToggle={handleToggle}
              showBrideGroom={showBrideGroom}
              setShowBrideGroom={setShowBrideGroom}
            />
          )}
        />
      </Skeleton>
      {/* {GuestList.map((group) => (
        <SingleGroup
          group={group}
          // handleToggle={handleToggle}
          showBrideGroom={showBrideGroom}
          setShowBrideGroom={setShowBrideGroom}
        />
      ))} */}
      <RsvpModal
        rsvpModal={rsvpModal}
        setrsvpModal={setrsvpModal}
        eventData={state?.eventData}
      />
    </>
  );
};

export default GuestList;
